import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {Rol} from "@enums";
import {MsalService} from "@azure/msal-angular";
import {AuthService} from "@services";

@Injectable({
  providedIn: 'root'
})
export class FuncionarioGuard implements CanActivate {

  constructor(private msalAuthService: MsalService,
              private authService: AuthService,
              private route: Router) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const userLogged = this.authService.getLoggedUser();
    if(userLogged.roles[0].rol == Rol.Validator || userLogged.roles[0].rol == Rol.Coordinator || userLogged.roles[0].rol == Rol.Director) {
      return true;
    } else {
      this.route.navigateByUrl('/');
      return false;
    }
  }

}
